import type { InvoiceStatus } from './types';

const STATUS_STYLES: Record<InvoiceStatus, string> = {
  DRAFT: 'bg-muted text-muted-foreground',
  SENT: 'bg-blue-100 text-blue-700',
  PAID: 'bg-green-100 text-green-700',
  OVERDUE: 'bg-red-100 text-red-700',
  CANCELLED: 'bg-muted text-muted-foreground',
  VOID: 'bg-orange-100 text-orange-700',
  EXPIRED: 'bg-amber-100 text-amber-700',
};

interface Props {
  status: InvoiceStatus;
}

export function InvoiceStatusBadge({ status }: Props) {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_STYLES[status] ?? 'bg-muted text-muted-foreground'}`}>
      {status}
    </span>
  );
}

/**
 * Labels the document itself — Invoice vs. Receipt — as a distinct concept from the payment
 * status badge above (PE-2105). A receipt is always "paid" by definition, so this is what
 * tells the two document types apart in a list or on the detail page.
 */
export function InvoiceDocumentTypeBadge({ isReceipt }: { isReceipt: boolean }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wide ${
        isReceipt ? 'bg-emerald-100 text-emerald-700' : 'bg-purple-100 text-purple-700'
      }`}
    >
      {isReceipt ? 'Receipt' : 'Invoice'}
    </span>
  );
}
